import { useQuery } from '@tanstack/react-query'
import { getUserSettings } from '../../../../apis/userSettings'
import { queryKeys } from '../../../../shared'

/**
 * ユーザー設定を取得する Query hook
 *
 * 設定画面でのみ使用されるため、ポーリングは不要。
 * staleTime はデフォルト設定（5分）を使用。
 */
export const useUserSettingsQuery = () => {
  return useQuery({
    queryKey: queryKeys.userSettings.current(),
    queryFn: getUserSettings,
  })
}
